import React, { useEffect, useRef } from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
  Chip,
} from "@mui/material";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  RocketLaunch,
  Code,
  DesignServices,
  CloudQueue,
  Security,
  Timeline,
  CheckCircle,
  Star,
  FlightTakeoff,
} from "@mui/icons-material";
export default function ViraItems({ index, item, itemsRef }) {
  return (
    <Box
      key={index}
      ref={(el) => (itemsRef.current[index] = el)}
      sx={{
        position: "relative",
        zIndex: 2,
        mb: 8,
        display: "flex",
        justifyContent: {
          xs: "flex-start",
          md: index % 2 === 0 ? "flex-start" : "flex-end",
        },
      }}
    >
      {/* center Circle */}
      <Box
        sx={{
          position: "absolute",
          left: { xs: "12px", md: "50%" },
          transform: "translateX(-50%)",
          width: 40,
          height: 40,
          borderRadius: "50%",
          background: `linear-gradient(135deg, ${item.color}, ${item.color}80)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `0 0 20px ${item.color}`,
          zIndex: 3,
          "&::before": {
            content: '""',
            position: "absolute",
            width: 60,
            height: 60,
            borderRadius: "50%",
            border: `1px solid ${item.color}40`,
            animation: "pulse 2s infinite",
          },
        }}
      >
        <Stack sx={{ fontSize: 20, color: "#fff" , my:"auto"}}>{item.icon}</Stack>
      </Box>

      {/* content Box */}
      <Box
        sx={{
          width: { xs: "calc(100% - 60px)", md: "45%" },
          ml: { xs: "60px", md: index % 2 === 0 ? 0 : "auto" },
          mr: { xs: 0, md: index % 2 === 0 ? "auto" : 0 },
          background: "rgba(255,255,255,0.03)",
          backdropFilter: "blur(10px)",
          borderRadius: 4,
          border: "1px solid rgba(255,255,255,0.05)",
          overflow: "hidden",
          transition: "all 0.3s",
          "&:hover": {
            transform: "translateY(-5px)",
            borderColor: item.color,
            boxShadow: `0 10px 30px ${item.color}20`,
          },
        }}
      >
        {/* year */}
        <Box
          sx={{
            background: `linear-gradient(135deg, ${item.color}, ${item.color}60)`,
            px: 3,
            py: 1.5,
            display: "inline-block",
          }}
        >
          <Typography
            sx={{
              fontSize: "1rem",
              fontWeight: 800,
              color: "#fff",
              letterSpacing: 2,
            }}
          >
            {item.year}
          </Typography>
        </Box>

        <Box sx={{ p: 3 }}>
          <Typography
            sx={{
              fontSize: "1.3rem",
              fontWeight: 700,
              color: "#fff",
              mb: 1,
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{
              fontSize: ".9rem",
              color: item.color,
              mb: 2,
              letterSpacing: 1,
            }}
          >
            {item.subtitle}
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "rgba(255,255,255,0.6)",
              lineHeight: 1.7,
              mb: 2,
            }}
          >
            {item.description}
          </Typography>

          {/* services tag */}
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {item.services.map((service, idx) => (
              <Chip
                key={idx}
                label={service}
                size="small"
                sx={{
                  bgcolor: `${item.color}20`,
                  color: item.color,
                  fontSize: 11,
                  height: 24,
                  "& .MuiChip-label": { px: 1.5 },
                }}
              />
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
